<template>
    <div class="contact">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               @before-close="beforeClose"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="model.created_at" class="display-block">
                        {{model.name}}

                        <span v-if="model.archivedLabel"
                              v-html="model.archivedLabel"></span>
                    </h4>

                    <h4 v-else class="display-block">
                        Create Contact
                    </h4>

                    <h5 v-if="model.created_at && model.title">
                        {{model.title}} -
                    </h5>

                    <h5 v-if="model.created_at && model.company">
                        <a :href="'/companies/' + model.company_id">
                            {{model.company.name}}
                        </a>
                    </h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <div class="row" v-if="model.created_at">
                    <div class="col-sm-6 form-group">
                        <dl>
                            <dt v-if="model.email">Email</dt>
                            <dd v-if="model.email">
                                <a :href="emailUrl" target="_blank">
                                    {{model.email}}
                                </a>
                            </dd>

                            <dt v-if="model.displayPhone">Phone</dt>
                            <dd v-if="model.displayPhone">
                                <a :href="telephoneUrl" target="_blank">
                                    {{model.displayPhone}}
                                </a>
                            </dd>
                        </dl>
                    </div>

                    <div class="col-sm-6 form-group">
                        <dl>
                            <dt>Address</dt>
                            <dd>
                                <addressable addressable-type="App\Contact"
                                             dependent-key="address_id"
                                             :address-id="model.address_id"
                                             :addressable-id="model.id"
                                             :afterSave="afterSave">
                                </addressable>
                            </dd>

                            <dt v-if="model.website">Website</dt>
                            <dd v-if="model.website">
                                <a :href="model.website" target="_blank">
                                    {{model.website}}
                                </a>
                            </dd>

                            <dt v-if="model.birthday_at">Birthday</dt>
                            <dd v-if="model.birthday_at">
                                {{model.birthday_at}}
                            </dd>
                        </dl>
                    </div>
                </div>

                <tabs>
                    <tab :title="model.created_at ? 'Edit' : 'Create'">
                        <form @submit.prevent="saveModel" accept-charset="UTF-8"
                              data-vv-scope="contact" novalidate="novalidate">

                            <div class="form-group has-feedback"
                                 :class="{'has-error': errors.has('contact.Contact[name]')}">
                                <label for="contact-name">Name</label>

                                <input id="contact-name"
                                       name="Contact[name]"
                                       type="text"
                                       class="form-control"
                                       v-model="model.name"
                                       v-validate="'required'">

                                <span v-show="errors.has('contact.Contact[name]')" class="help-block">
                                    {{ errors.first('contact.Contact[name]') }}
                                </span>
                            </div>

                            <div v-if="companies.length > 1" class="form-group has-feedback"
                                 :class="{'has-error': errors.has('contact.Contact[company_id]')}">
                                <label for="contact-company-id">Company</label>

                                <select id="contact-company-id"
                                        name="Contact[company_id]"
                                        class="form-control"
                                        v-validate="'required'"
                                        v-model="model.company_id">
                                    <option value="">-</option>
                                    <option v-for="listCompany in companies"
                                            :value="listCompany.id">
                                        {{ listCompany.name }}
                                    </option>
                                </select>

                                <span v-show="errors.has('contact.Contact[company_id]')" class="help-block">
                                        {{ errors.first('contact.Contact[company_id]') }}
                                    </span>
                            </div>

                            <div class="row">
                                <div class="form-group has-feedback col-sm-6"
                                     :class="{'has-error': errors.has('contact.Contact[title]')}">
                                    <label for="contact-title">Title</label>
                                    <input id="contact-title"
                                           name="contact.Contact[title]"
                                           type="text"
                                           class="form-control"
                                           v-model="model.title">
                                    <span v-show="errors.has('contact.Contact[title]')" class="help-block">
                                        {{ errors.first('contact.Contact[title]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback col-sm-6"
                                     :class="{'has-error': errors.has('contact.Contact[email]')}">
                                    <label for="contact-email">Email</label>
                                    <input id="contact-email"
                                           name="contact.Contact[email]"
                                           type="text"
                                           class="form-control"
                                           v-validate="'email'"
                                           v-model.string="model.email">

                                    <span v-show="errors.has('contact.Contact[email]')" class="help-block">
                                        {{ errors.first('contact.Contact[email]') }}
                                    </span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="form-group has-feedback col-sm-6">
                                    <label for="contact-phone">Phone</label>
                                    <input id="contact-phone"
                                           name="Contact[phone]"
                                           type="text"
                                           class="form-control"
                                           v-model="model.phone">
                                    <span v-show="errors.has('contact.Contact[phone]')" class="help-block">
                                        {{ errors.first('contact.Contact[phone]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback col-sm-6"
                                     :class="{'has-error': errors.has('contact.Contact[website]')}">
                                    <label for="contact-website">Website</label>
                                    <input id="contact-website"
                                           name="Contact[website]"
                                           type="text"
                                           class="form-control"
                                           v-validate="{url: {require_protocol: true }}"
                                           v-model="model.website">

                                    <span v-show="errors.has('contact.Contact[website]')" class="help-block">
                                        {{ errors.first('contact.Contact[website]') }}
                                    </span>
                                </div>
                            </div>

                            <hr>

                            <div class="row">
                                <div class="col-xs-6 form-group">
                                    <div v-if="model.created_at">
                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="restoreModel"
                                                v-if="model.deleted_at"
                                                :disabled="loading">
                                            <i class="fa fa-refresh" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-warning" @click="deleteModel"
                                                v-else
                                                :disabled="loading">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>

                                <div class="col-xs-6 form-group">
                                    <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </tab>
                </tabs>
            </div>
        </modal>
    </div>
</template>

<script>
    import model from "./mixins/model";

    export default {
        mixins: [ model ],

        props: {
            companyIds: {
                required: true,
                type: Array,
                default: () => {
                    return [];
                }
            },
        },

        computed: {
            url(){
                if( this.model.id ){
                    return '/api/contacts/' + this.model.id;
                }
                else {
                    return '/api/contacts';
                }
            },

            saveValidationKey(){
                return 'contact'
            },

            resourceKey(){
                return 'Contact';
            },

            companyId(){
                if( this.contact.company_id ){
                    return this.contact.company_id;
                }
                else if( this.companies.length > 0 ){
                    return _.head( this.companies ).id;
                }

                return null;
            },

            telephoneUrl(){
                if( !this.model.phone ){
                    return "";
                }

                return "tel:" + this.model.phone;
            },

            emailUrl(){
                if( !this.model.email ){
                    return "";
                }

                return "mailto:" + this.model.email;
            },
        },
        methods: {
            getModelData(){
                return {
                    companies: [],
                };
            },

            beforeLoad(){
                return this.loadCompanies();
            },

            loadCompanies(){
                return axios.get( '/api/companies?ids=' + encodeURI( this.companyIds ) )
                    .then( ( result ) => {
                        return this.$set( this, 'companies', result.data.Companies );
                    } );
            },
        }
    }
</script>
